module.exports = __webpack_public_path__ + "static/media/home-apple-pay.fb87d7c1.png";